// Base URL for the website, used for OpenGraph if no URL is provided from API
export const BASE_URL = "https://dreamcase.eu";
export const DEFAULT_OG_IMAGE = "/tesla-mattress-dreamcase.jpeg";
export const DEFAULT_OG_IMAGE_ALT = "DreamCase Mattresses";
